<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">プロフィール</h2>
        <v-form ref='writerProfileForm'>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-if="includedAllowedKey('id')"
                :value="user.id"
                class="mb-3"
                label="ユーザーID"
                disabled
                style="width: 100px"
                required
              />
              <v-text-field
                v-if="includedAllowedKey('name')"
                v-model="user.name"
                class="mb-3"
                style="width: 300px"
                :rules="[presenceValidation]"
                required
              >
                <template v-slot:label>
                  <InputLabel labelName="名前（表示名）" :required="true" />
                </template>
              </v-text-field>
              <div v-if="includedAllowedKey('avatar')">
                <ImageFormAndThumbnail
                  label-name='プロフィール画像'
                  :requiredImageFile="true"
                  :propsImagePreviewURL='user.avatar.url'
                  @change-image-file="(value) => user.avatar = value"
                ></ImageFormAndThumbnail>
              </div>
              <v-text-field
                v-if="includedAllowedKey('title')"
                v-model="user.title"
                class="mb-2"
                label="肩書き"
                style="width: 300px"
              />
              <v-text-field
                v-if="includedAllowedKey('crowdworksName')"
                v-model="user.crowdworksName"
                class="mb-4"
                label="クラウドワークス名"
                style="width: 300px"
              />
              <v-textarea
                v-model="user.introduction"
                class="mb-2 body-2"
                label="ライタープロフィール"
                style="width: 400px"
                outlined
                rows="3"
              />
              <profile-links-form
                :profile-links="user.profileLinks"
                :destroy-profile-links="destroyProfileLinks"
                ref='profileLinksForm'
              />
              <v-switch
                v-if="currentUser.isAdmin"
                v-model="user.writerPagePublished"
                label="ライターページを公開する"
              />
            </v-col>
          </v-row>
          <v-btn
            color="green darken-1"
            tile
            dark
            depressed
            @click="updateProfile"
          >
            更新
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import ProfileLinksForm from '@/components/commons/ProfileLinksForm'
import snakecaseKeys from 'snakecase-keys'
import { mapState } from 'vuex'
import _ from 'lodash'
import ImageFormAndThumbnail from './ImageFormAndThumbnail'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'WriterProfile',
  components: {
    ProfileLinksForm,
    ImageFormAndThumbnail,
    InputLabel
  },
  mixins: [formValidationUtils],
  props: {
    userId: {
      type: String,
      required: true
    },
    allowedKeys: {
      type: Array,
      default: () => [
        'id',
        'name',
        'title',
        'avatar',
        'introduction',
        'crowdworksName',
        'profileLinks'
      ]
    }
  },
  data: () => {
    return {
      user: {},
      destroyProfileLinks: [],
      sizeValidation: (value) => {
        if (!value) return true

        if (value.size > 5000000) {
          return '画像サイズは5MB未満にして下さい'
        } else {
          return true
        }
      }
    }
  },
  mounted () {
    axios.get(`/api/users/${this.userId}`).then(
      ({ data }) => {
        const user = data.data.attributes
        this.user = this.filterUserObject(user)
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: `ユーザー情報の取得に失敗しました（${error.response.data.errors.toString()}）`
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload, {
          root: true
        })
      }
    )
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  methods: {
    updateProfile () {
      if (!this.$refs.writerProfileForm.validate() || !this.$refs.profileLinksForm.validate()) return false

      let formData = new FormData()
      Object.keys(this.user).forEach((key) => {
        if (this.user[key] !== null) {
          formData.append(`user[${_.snakeCase(key)}]`, this.user[key])
        }
      })
      const sendProfileLinks = this.user.profileLinks.concat(
        this.destroyProfileLinks
      )
      let arr = snakecaseKeys(sendProfileLinks)
      arr = arr.map(obj => {
        const {_destroy, ...rest} = obj
        return {_destroy: obj.destroy, ...rest}
      })
      formData.append('user[profile_links_attributes]', JSON.stringify(arr))
      formData.append('_method', 'PATCH')
      axios
        .post(`/api/users/${this.user.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const user = data.data.attributes
            this.user = this.filterUserObject(user)
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    filterUserObject (user) {
      return Object.keys(user)
        .filter((key) => this.includedAllowedKey(key))
        .reduce((obj, key) => {
          obj[key] = user[key]
          return obj
        }, {})
    },
    includedAllowedKey (key) {
      return this.allowedKeys.includes(key)
    }
  }
}
</script>

<style scoped></style>
